import axios from 'axios'
import WebchatService from './webchat'
import InternalChatService from './internalChat'
import UploadService from './upload'
import UserService from './user'
import GroupService from './group'
import NotifyService from './notify'
import AuditService from './audit'

const url = `${process.env.VUE_APP_API_URL}/${process.env.VUE_APP_API_PATH}`

const httpClient = axios.create({
  baseURL: url
})

httpClient.interceptors.response.use((response) => {
  return response
}, (error) => {
  const canThrowAnError = error.request.status === 0 || error.request.status === 500

  if (canThrowAnError) {
    throw new Error(error.message)
  }
  if(error.response.status === 413) {
    throw new Error('Arquivo muito grande')
  }
  return error
})

export default {
  webchat: WebchatService(httpClient),
  internalChat: InternalChatService(httpClient),
  upload: UploadService(httpClient),
  group: GroupService(httpClient),
  user: UserService(httpClient),
  notify: NotifyService(httpClient),
  audit: AuditService(httpClient)
}
